import React from "react";
import styles from "./TextArea.module.scss";
import {
  Controller,
  type Control,
  type FieldValues,
  type RegisterOptions,
  type UseFormRegisterReturn,
} from "react-hook-form";
import withLabelAndError from "../withLabelAndError";

interface TextAreaProps<TFieldValues extends FieldValues = FieldValues> {
  control?: Control<TFieldValues>;
  register?: (name: string, options?: RegisterOptions) => UseFormRegisterReturn;
  validations?: RegisterOptions;
  name: string;
  placeholder?: string;
  type?: string; // rarely used for textarea, but kept for compatibility
  [key: string]: any; // allow extra props like rows, cols, etc.
}

const TextArea = <TFieldValues extends FieldValues = FieldValues>({
  control,
  register,
  validations,
  name,
  placeholder,
  type,
  ...rest
}: TextAreaProps<TFieldValues>) => {
  const renderTextArea = (field: Partial<UseFormRegisterReturn> = {}) => (
    <textarea
      {...field}
      {...rest}
      id={name}
      className={styles.inputField}
      placeholder={placeholder}
    />
  );

  if (control) {
    return (
      <Controller
        control={control}
        rules={validations}
        name={name}
        render={({ field }) => renderTextArea(field)}
      />
    );
  } else {
    const field = register ? register(name, validations) : {};
    return renderTextArea(field);
  }
};

export default withLabelAndError(TextArea);
export { TextArea };
